<template>
  <body class="pages-body flex flex-column align-items-center justify-content-center" >
    <object class="overlay"  data="/layout/images/spinner.svg" width="100" height="100"> </object>
  </body>
</template>

<script setup>
import router from "@/routes";
import {getCurrentI18n} from "@/locales/i18n";

setTimeout(() => {
  router.push({ name: "main_page", params: { locale: getCurrentI18n() } });

}, 5000);
</script>
